<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Neskladja {{$route.query.title}}</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
      <div>
        <div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezoneBranje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
            /> 
            
          </div>
        </div>
      
    <div class="uporabnik-spacer" style="margin-top:2rem"></div>
     <div class="columnBar">
              Skriti stolpci:
              <multiselect 
                        :data-items="columns"
                        :text-field="'title'"
                        :data-item-key="'field'"
                        :placeholder="'Skrij stolpce'"
                        @change="spremenistolpce($event)"
                        
                        :auto-width="true"
                        :value="hiddenColumns2"
                        >
            </multiselect>
        </div>
    <Grid  
                       
                        :sortable="sortable"
                        :filterable="filterable"
                     
                         :pageable="{ buttonCount: 4, pageSizes: [10,50,100,'all'] }"
                        :data-items="neskladja"
                        :skip="skip"
                        :take="take" 
                        :sort="sort" 
                        :resizable="true"
                      
                        :filter="filter" 
                        :columns="columns"
                        @datastatechange="dataStateChange"

                        
                       
                        @pagechange="pageChangeHandler"
                       
                        
                                              

                         
                        
                                               >
                    <template v-slot:checkbox="{props}">
                      <checkbox :checked="props.dataItem[props.field]"/>
                    </template>
                    <template v-slot:cbItem="{props}">
      <td>
                      <input type="checkbox" v-model="props.dataItem[props.field]" class="k-checkbox"/>
                    </td>
                    </template>


                    <template v-slot:shemaCommandCellSlot="{props, methods}">
                        
                      
                  
                    <shemaCommandCell :ukazi="ukazi" :dataItem="props.dataItem.stranka" :shema="$route.query.title" :sezona="dataSezona.sezona"
                    :kontrolaid="props.dataItem._id"
                    :podshema="props.dataItem.podrocjecertificiranja"
                      
                      />
                    </template>

                    <template v-slot:shemaCell="{props}">
                      <shemaCell :sheme="props.dataItem.stranka.sheme.filter(s=>(s.jeaktivna&&s.sezona==$trenutnasezona&&s.shema!='IP'))"/>
                    </template>
                      <template v-slot:uredi="{props}">
                      <td>
                        <kbuttongroup>
                            
                        <kbutton title="Uredi zapisnik" theme-color="primary" @click="ukaz('kontrolaip',props.dataItem,$event)" ><font-awesome-icon :icon="'list-check'"/> </kbutton>
                        <kbutton   :disabled="!isAdmin" title="Nadaljni ukrepi" theme-color="primary" @click="ukaz('kontrolaukrepip',props.dataItem,$event)" ><font-awesome-icon :icon="'person-circle-exclamation'"/> </kbutton>
                        <kbutton title="Priprava" theme-color="primary" @click="ukaz('pripravakontroleip',props.dataItem,$event)" ><font-awesome-icon :icon="'book-open-reader'"/> </kbutton>
                     
                        <kbutton title="Gerki" theme-color="primary" @click="ukaz('gerkip',props.dataItem,$event)" ><font-awesome-icon :icon="'draw-polygon'"/> </kbutton>
                     
                        <kbutton title="Kontrolne točke prenesi" theme-color="primary" @click="prenesiobrazecip(props.dataItem,$event)" ><font-awesome-icon :icon="'file-arrow-down'"/> </kbutton>
                     
                        <kbutton v-if="isAdmin&&isKontrolnoPorociloNR" title="Kontrolne točke prenesi - nova revizija" theme-color="primary" @click="prenesiobrazecipnr(props.dataItem,$event)" ><font-awesome-icon :icon="'file-pen'"/> </kbutton>
                        <kbutton title="Kontrolne točke naloži" theme-color="primary" @click="ukaz('dodajobrazecip',props.dataItem,$event)" ><font-awesome-icon :icon="'file-arrow-up'"/> </kbutton>
                        <kbutton title="Prikaži neskladja" theme-color="primary" @click="ukaz('neskladjaip',props.dataItem,$event)" ><font-awesome-icon :icon="'file-circle-exclamation'"/> </kbutton>
                        <kbutton :disabled="!isAdmin" title="Certifikati" theme-color="primary" @click="ukaz('certifikatip',props.dataItem,$event)" ><font-awesome-icon :icon="'certificate'"/> </kbutton>
                        </kbuttongroup>
                        
                      </td>
                    </template>
                        <toolbar>
                             
                        <kbuttongroup>
                            <kbutton 
                                title="Izvozi v Excel"
                                @click="exportExcel"
                                theme-color="primary"
                            >
                                Izvozi v Excel
                            </kbutton>
                            <kbutton 
                                v-if="$route.query.title=='IP'"
                                title="Dodeli kontrole"
                                @click="dodelikontrole"
                                theme-color="primary"
                                :disabled="!isAdmin"
                            >
                                Dodeli kontrole
                            </kbutton>    
                        </kbuttongroup>
                        
                            
                        </toolbar>
                    </Grid>

                    </div>
    </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
//import '@progress/kendo-ui' // This will import the entire Kendo UI library
import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';
import { Grid, GridToolbar } from '@progress/kendo-vue-grid';
import { MultiSelect, DropDownList } from '@progress/kendo-vue-dropdowns';
import { saveExcel } from '@progress/kendo-vue-excel-export';
import { Button, ButtonGroup } from '@progress/kendo-vue-buttons';
import { obrazecService } from '../services/obrazec.service';


import { process } from '@progress/kendo-data-query';
import CheckBoxGridItem from './support/CheckBoxGridItem';
import ShemaCommandCell from './support/ShemaCommandCell';
import ShemaCell from './support/ShemaCell';

/*
Vue.component('checkbox', CheckBoxGridItem);

Vue.component('kbutton', Button);
Vue.component('kbuttongroup', ButtonGroup);
Vue.component('multiselect', MultiSelect);
Vue.component('shemaCommandCell', ShemaCommandCell);
Vue.component('Grid', Grid);
Vue.component('toolbar', GridToolbar);
Vue.component('dropdownlist', DropDownList);
*/



export default {
    components:{
      
      'multiselect': MultiSelect, 
      'shemaCell': ShemaCell,
      'checkbox': CheckBoxGridItem,
      'kbutton': Button,
      'kbuttongroup': ButtonGroup,
      'shemaCommandCell': ShemaCommandCell,
      'Grid': Grid,
      'toolbar': GridToolbar,
      'dropdownlist': DropDownList,
    }
      ,
  props:['shema'],
    data () {
        return {
         
            dataSezona:this.sezona,
            neskladja:[],
     
            


            filter: null,
            editID: null,
            skip: 0,
            take: 10,
            pageSize: 10,
            sortable: true,
            filterable: true,
            groupable: false,
            dataResult: [],
            ukazi:[ {title:"Uredi zapisnik",akcija:"kontrolaip",icon:"list-check"},
               {title:"Nadaljni ukrepi",akcija:"kontrolaukrepip",icon:"person-circle-exclamation"},
               {title:"Priprava",akcija:"pripravakontroleip",icon:"book-open-reader"},
               {title:"Gerki",akcija:"gerkip",icon:"draw-polygon"},
               {title:"Kontrolne točke prenesi",akcija:"prenesiobrazecip",icon:"file-arrow-down"},
               {title:"Kontrolne točke prenesi - nova revizija",akcija:"prenesiobrazecipnr",icon:"file-pen"}],
            hiddenColumns2:[],
         
            sort: [
                //{ field: 'vrstakulture', dir: 'asc' }
            ],
           
          

           

        }
    },
    created () {

      
      /*
   
        if(!this.$route.query.sezona)
            this.dataSezona={sezona:2022};
        else
            this.dataSezona={sezona:this.$route.query.sezona};


     this.loadVse({sezona:this.dataSezona.sezona,shema:this.$route.query.title});
     */
     this.naloziPodatke(this.$route.query.title,this.$route.query.sezona);
 
    },
      beforeRouteUpdate (to, from,next) {
        
        this.naloziPodatke(to.query.title,to.query.sezona,next);

        /*
        if(!to.query.sezona)
            this.dataSezona={sezona:2023};
        else
            this.dataSezona={sezona:to.query.sezona};
        
       //this.naloziPodatke(to.query.title,to.query.sezona,next);
       
       this.loadVse({sezona:this.dataSezona.sezona,shema:to.query.title});
       */
    

 
    },
    computed: {
        isAdmin(){
            if(!this.userDetails)
                return false;

            return this.userDetails.pravice.includes('admin')
        },
        isKontrolnoPorociloNR(){
            if(!this.userDetails)
                return false;
            if(!this.userDetails.obrazciRevizije)
                return false;
            return this.userDetails.obrazciRevizije.includes('kontrolnoporocilo')
        },
        columns() {

let  columns= [
                { field: "zaporednastevilka", title:"Zaporedna št. kontrole",width: "100px",filterable:false,footerCell:this.nogaNazivVsot},
                { field: "datumkontrole", filterable:false, title:"Datum kontrole",width: "190px", type:"date",format:"{0:d}",footerCell:this.nogaSteviloKontrol},
                { field: "trajanje", title:"Trajanje (h)",width: "100px",filterable:false},
                { field: "vrstakontrole", title:"Vrsta kontrole"},
                { field: "nacinkontrole", title:"Način kontrole"},
                //{ field: "vzorci", title:"Vzorci",width: "100px",hidden:true},
                //{ field: "posebnosti", title:"Posebnosti",width: "100px",hidden:true},
                //{ field: "priloge", title:"Priloge",width: "100px",hidden:true},
                { field: "mnenjekontrolorja", title:"Mnenje kontrolorja",width: "100px",hidden:true},
                { field: "kontrolor", title:"Kontrolor",width: "100px"},
                { field: "datumcertificiranja", filterable:false, title:"Datum cert.",width: "190px", type:"date",format:"{0:d}"},
                { field: "certifikator", title:"Certifikator",width: "100px"},
                 { field: "stranka.naziv", title:"Nosilec",width: "150px"},
                 { field: "stranka.kmgmid", title:"KMG-MID",width: "150px",footerCell: this.nogaStMidov},


                { field: "stranka.postnastevilka", title:"Poštna številka"},
               
                { field: "stranka.posta", title:"Pošta"},
               


            

                //to troje dodat v vse???? vsaj kontrolno številko
            /*
               { field: "imenosilca", title:"Nosilec",width: "150px"},
                
                  { field: "kontrolnastevilka", title:"Kontrolna št.",width: "150px"},
                { field: "statuspridelovalca", title:"Status",width: "150px"},
            */    
           
            ];
//if(this.userDetails.pravice.includes("STRANKE_PISI"))
    //columns.unshift({ title: "Ukazi", cell: "shemaCommandCellSlot",filterable:false,columnMenu: null,width:((this.ukazi.length*28)+6)+"px",sortable:false});

//if(this.userDetails.pravice.includes("STATISTIKA_BERI"))
  //  columns.push({ field: "kontrolnaorganizacija", title:"V kontroli pri"});
/*
  if(this.$route.query.title=="EKO PRI"||this.$route.query.title=="EKO PRE"){
    
    columns.push({field:"kategorije", title:"Kategorije",cell:"kategorijaCell",});
    columns.push({field:"dejavnosti" ,title:"Certificirane dejavnosti",cell:"dejavnstiCell",});
    columns.push({field:"vsedejavnosti" ,title:"Vse dejavnosti",cell:"dejavnstivseCell", hidden:true});
    columns.push({field:"status.status" ,title:"Status"});
    //{ field: "sheme", title:"Dejavnosti",cell:"shemaCell",filterCell: 'filterSlotTemplate'},
  }
  */
  if(this.$route.query.title=="IP"){
    
    columns=[

           //    { field: "zaporednastevilka", title:"ID",width: "100px",filterable:false,footerCell:this.nogaNazivVsot,type:"number",editable:false,width: "50px"},
            //   { cell: "shemaCommandCellSlot", title:"Uredi",width: this.isAdmin?"270px":"250px",filterable:false},
               //{ cell: "shemaCommandCellSlot", title:"Uredi2",width: this.isAdmin?"250px":"230px",filterable:false},
			   { field: "kontrola.status", title:"Status nazdora",width: "150px"},
               
               
               { field: "kontrola.vrstakontrole", title:"Vrsta kontrole",width: "220px"},
			   //{ field: "shema", title:"shema"},
              // { field: "vzorcenje", cell:"checkbox", title:"Vzorčenje",width: "80px",filterable:false},

			   { field: "kontrola.podrocjecertificiranja", title:"podrocje",width: "60px"},
			   { field: "kontrola.izvajalec", title:"Izvajalec",width: "100px"},
              
               { field: "kontrolnatocka", title:"Knt. točka",width: "80px"},
               { field: "skladnost", title:"Skladnost",width: "80px"},
                            { field: "komentar", title:"Opis neskladnosti",width: "150px"},
                            { field: "stopnjaneskladja", title:"Stopnja", width: "80px" },
                            { field: "ukrep", title:"Ukrep", editable:false, width: "150px" },
                            { field: "rok", title:"Rok za odpravo", editable:false,width: "150px", type:"date",editor:"date",format:"{0:d}" },
                            { field: "odpravljeno", title:"Odpravljeno", editable:true,width: "100px", cell:"cbItem",editor:"boolean" },
                            { field: "datumodprave", title:"Datum odprave", editable:true, width: "150px", type:"date",editor:"date",format:"{0:d}"},
                            { field: "komentarodprave", title:"Komentar",editable:true,width: "350px"},
             //  { field: "kontrola.izvajalec", title:"Izvajalec",width: "100px"},
//               { field: "kontrola.izvajalec", title:"Izvajalec",width: "100px"},
            

                /*
			   { field: "naslov", title:"Naslov",width: "100px",filterable:false},
               { field: "naslovkmetija", title:"Naslov kmetije",width: "100px",filterable:false},
               { field: "postnastevilkakmetija", title:"Poštna št. kmetije",width: "100px"},
               { field: "postakmetija", title:"Pošta kmetije",width: "100px",filterable:false},
               { field: "telefon", title:"Telefon",width: "100px",filterable:false},
               { field: "email", title:"Email",width: "100px",filterable:false},
               { field: "rokizvedbe", filterable:false, title:"Rok izvedbe",width: "150px", type:"date",editor:"date",format:"{0:d}"},
			   { field: "datumkontrole", filterable:false, title:"Datum kontrole",width: "150px", type:"date",editor:"date",format:"{0:d}"},
               { field: "trajanje", title:"Trajanje (hh:mm)",width: "100px",filterable:false},
            
			   

			   { field: "kontrolornaziv", title:"Kontrolor",width: "240px"},
               { field: "mnenjekontrolorja", title:"Mnenje",width: "90px"},
               { field: "dodeljevalecnaziv", title:"Dodelil",width: "90px",hidden:true},
               { field: "datumdodelitve", filterable:false, title:"Datum dodelitve",width: "150px", type:"date",editor:"date",format:"{0:d}",hidden:true},
             
               { field: "certifikator", title:"Certifikator",width: "90px",hidden:true},
               { field: "datumodlocitve", filterable:false, title:"Datum odločitve",width: "150px", type:"date",editor:"date",format:"{0:d}",hidden:true},
               { field: "ipcena", title:"Cena",width: "90px",hidden:true},
               { field: "sheme", title:"Druge sheme",cell:"shemaCell",hidden:true,filterable:false,width: "120px",},
               { field: "povrsinaIP", title:"Površina (a)",hidden:true,width: "120px"},
               { field: "iukrepstatus", title:"Ukrepi izvajalca",hidden:true,width: "120px"},
               { field: "nukrepstatus", title:"Ukrepi nadzora",hidden:true,width: "120px"},
               { field: "neskladjastatus", title:"Neskladja",hidden:true,width: "120px"},
               */

			   //{ field: "tveganje", title:"Ocena tveganja",filterable:false},
			   //{ field: "cena", title:"Cena",filterable:false},
			   //{ field: "statusplacila", title:"Status plačila"},
			 
            //{ cell: 'ukaznigumbi', width: '210px', hidden:this.editDisabled },
            //dodaj
            //odločitev izvedel
            //številka certifikata

            ];
  }
/*
    columns.find(c=>c.field=="kmgmid").hidden=false;
    columns.splice(4,0,{field:"ippodrocja", title:"Področja",cell:"ipCell",filterCell:"filterIPTemplate",width:"240px"});

    for(let podshema of this.ipsheme){
    columns.splice(4,0,{field:podshema.naziv, title:"Obseg "+podshema.naziv,cell:"obseg",width:"240px", hidden:true});
    columns.splice(4,0,{field:podshema.naziv+"_sifra", title:"Šifre obsega "+podshema.naziv,cell:"obseg",width:"240px", hidden:true});
    }
    
    
    columns.splice(8,0,{ field: "postakmg", title:"Pošta KMG", hidden:true})
    columns.splice(8,0,{ field: "postnastevilkakmg", title:"Poštna št.KMG", hidden:true})
    columns.splice(8,0,{ field: "naslovkmg", title:"Naslov KMG", hidden:true})
    columns.splice(8,0,{ field: "emailoo", title:"E-pošta"})
    columns.splice(8,0,{ field: "telefonoo", title:"Telefon"})
    
    

} 
if(this.$route.query.title=="EKO PRI"){
    columns.push({ field: "spletnastran", title:"Spletna stran", hidden:true})
    columns.push({ field: "povrsina_p", title:"Površina P (a)", hidden:true});
    columns.push({ field: "povrsina_eko", title:"Površina EKO (a)", hidden:true});
    columns.push({ field: "povrsina_skupaj", title:"Površine (a)", hidden:true});
    columns.push({ field: "tocke_povrsina", title:"Točke površine", hidden:true});
    columns.push({ field: "kolicina", title:"Količina", hidden:true});
    columns.push({ field: "tocke_kolicina", title:"Točke količine", hidden:true});
    
    //{ field: "sheme", title:"Dejavnosti",cell:"shemaCell",filterCell: 'filterSlotTemplate'},
  }
*/


this.hiddenColumns2=columns.filter(c=>c.hidden);
return columns;


},

         
...mapState('users', ['userDetails','sezoneBranje','sheme']),
         ...mapState({gridData(state) {
      
          return state.kontrola.kontrola;
        }}),         
    
           },
      watch: {
        skip(newValue, oldValue){
            console.log(`Updating from ${oldValue} to ${newValue}`);

            const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.gridData, dataState);
        },
        take(newValue, oldValue){
            console.log(`Updating from ${oldValue} to ${newValue}`);
            
            const dataState = {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                group: this.group
            }
        this.dataResult = process( this.gridData, dataState);
        },
       gridData(newValue, oldValue) {
  

      if(newValue){
        const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.gridData, dataState);

        }
    }
},
    methods: {
        uredikontrolo(kontrola){
            console.log(kontrola)
            var shema=this.$route.query.title;
            var sezona=this.dataSezona.sezona;
            var pridelovalecid=kontrola.pridelovalecid;
            var kontrolaid=kontrola._id;

            

            this.$router.push({ name: 'kontrolaip', params: { sezona:sezona,shema:shema,pridelovalecid:pridelovalecid,kontrolaid:kontrolaid} })
            

        },
        urediukrepe(kontrola){
            
            var shema=this.$route.query.title;
            var sezona=this.dataSezona.sezona;
            var pridelovalecid=kontrola.pridelovalecid;
            var kontrolaid=kontrola._id;

            

            this.$router.push({ name: 'kontrolaukrepip', params: { sezona:sezona,shema:shema,pridelovalecid:pridelovalecid,kontrolaid:kontrolaid} })
            

        },
        ipcenaizpovrsine(povrsina,shema){
            let sifrantcene=[{"shema":"IPG","meja":0,"cena":28},{"shema":"IPG","meja":1,"cena":30},{"shema":"IPG","meja":3,"cena":32},{"shema":"IPG","meja":5,"cena":34},{"shema":"IPG","meja":10,"cena":36},{"shema":"IPG","meja":20,"cena":38},{"shema":"IPS","meja":0,"cena":28},{"shema":"IPS","meja":1,"cena":31},{"shema":"IPS","meja":3,"cena":34},{"shema":"IPS","meja":5,"cena":37},{"shema":"IPS","meja":10,"cena":40},{"shema":"IPS","meja":20,"cena":43},{"shema":"IPP","meja":0,"cena":35},{"shema":"IPP","meja":1.01,"cena":38},{"shema":"IPP","meja":5,"cena":41},{"shema":"IPP","meja":15,"cena":45},{"shema":"IPP","meja":50,"cena":50},{"shema":"IPP","meja":100,"cena":60},{"shema":"IPP","meja":500,"cena":90},{"shema":"IPZ","meja":0,"cena":35},{"shema":"IPZ","meja":1.1,"cena":40},{"shema":"IPZ","meja":3.1,"cena":45},{"shema":"IPZ","meja":5,"cena":55},{"shema":"IPH","meja":0,"cena":35},{"shema":"IPH","meja":1.01,"cena":38},{"shema":"IPH","meja":5,"cena":41},{"shema":"IPH","meja":15,"cena":45},{"shema":"IPH","meja":50,"cena":50},{"shema":"IPH","meja":100,"cena":60},{"shema":"IPH","meja":500,"cena":90}]
            let cene=sifrantcene.filter(s=>s.shema==shema&&s.meja*100<povrsina).map(i=>i.cena);
            if(!cene||cene.length==0)
                return 0
            else
                return Math.max(...cene);
            
        },
        naloziPodatke(shema,sezona,next){

        this.loading=true;
            if(!sezona)
            this.dataSezona={sezona:this.$trenutnasezona};
        else
            this.dataSezona={sezona:parseInt(sezona)};
        
        sezona=this.dataSezona.sezona;
        var thisComp=this;
        
        this.loadVse({sezona:this.dataSezona.sezona,shema:shema}).then(()=>{


            thisComp.ukazi=thisComp.sheme?.find(i=>i.kratica=="IP")?.ukazikontrole;
            
            for (let p of this.gridData){
                let kontakt=p.stranka.kontakt.find(k=>k.vloga=="nosilec kmg")
                if(!kontakt)
                    kontakt=p.stranka.kontakt.find(k=>k.glavni)
                if(!kontakt)
                    kontakt=p.stranka.kontakt[0];

                let kontaktkmg=p.stranka.kontakt.find(k=>k.vloga=="kmetija (kmg)")
                if(!kontaktkmg)
                    kontaktkmg=p.stranka.kontakt.find(k=>k.glavni)
                if(!kontaktkmg)
                    kontaktkmg=p.stranka.kontakt[0];
                    
                Vue.set(p,"izvajalec",kontakt.naziv);
                Vue.set(p,"naslov",kontakt.naslov);
                Vue.set(p,"postnastevilka",kontakt.postnastevilka);
                Vue.set(p,"posta",kontakt.posta);
                Vue.set(p,"naslovkmetija",kontaktkmg.naslov);
                Vue.set(p,"postnastevilkakmetija",kontaktkmg.postnastevilka);
                Vue.set(p,"postakmetija",kontaktkmg.posta);
                if(shema=="IP"){
                    var ipshema=p.stranka.sheme.find(s=>s.shema==shema&&s.sezona==sezona);
                    var oseba=ipshema?.ip?.osebe?.find(i=>i);
                    
                    Vue.set(p,"telefon",oseba?.telefon);
                    Vue.set(p,"email",oseba?.email);
                    Vue.set(p,"vzorcenje",p.vzorcenje);

                    Vue.set(p,"stgerkov",p.gerki.filter(g=>g.sezona==sezona).length);
                    Vue.set(p,"stgerkovkontrola",p.gerki.filter(g=>g.sezona==sezona&&g.kontrolaIP).length);
                    Vue.set(p,"stgerkovogled",p.gerki.filter(g=>g.sezona==sezona&&g.ogledIP).length);

                    Vue.set(p,"certifikator",p.odlocitev.kontrolor?.naziv);
                    Vue.set(p,"datumodlocitve",p.odlocitev.datumodlocitve);
                    
                    let iukrepstatus="";
                    let ukrepiizvajalca=p.ukrepizvajalca.filter(u=>!u.zakljucil);
                    let nukrepstatus="";
                    let ukrepinadzor=p.ukrepnadzor.filter(u=>!u.zakljucil);
                    
                    if(ukrepiizvajalca.length>0)
                    iukrepstatus="odprti";
                    
                    if(ukrepiizvajalca.filter(u=>{
                        return (((new Date(u.rok))<(new Date()))&&!u.podaljsanrok)||(u.podaljsanrok&&((new Date(u.podaljsanrok))<=(new Date())));
                    }
                    ).length>0)
                    iukrepstatus="zamujeni";

                    if(ukrepinadzor.length>0)
                    nukrepstatus="odprti";
                    

                    let neskladjastatus="";
                    if(!p.neskladja)
                    p.neskladja=[];
                    let neskladja=p.neskladja.filter(n=>n.skladnost=="NE"&&!n.odpravljeno);
                    if(p.neskladja.length>0)
                        neskladjastatus="odprta"

                    if(neskladja.filter(n=>(new Date(n.rok))<(new Date())).length>0)
                        neskladjastatus="zamujena"


                    
                    Vue.set(p,"iukrepstatus",iukrepstatus);
                    Vue.set(p,"nukrepstatus",nukrepstatus);
                    Vue.set(p.stranka,"iukrepstatus",iukrepstatus);
                    Vue.set(p.stranka,"nukrepstatus",nukrepstatus);

                    Vue.set(p,"neskladjastatus",neskladjastatus);
                    Vue.set(p.stranka,"neskladjastatus",neskladjastatus);

                    let cena=0;
                    let povrsine={};
                    if(!p.ippovrsine)
                    Vue.set(p,"ippovrsine",{});

                    //for(let pc of ipshema.ip.podrocjacertificiranja.filter(p=>p.status.id==1)){
                        let gerkipc=p.gerki.filter(g=>g.sezona==sezona&&g?.kontrolaIP&&g.kontrolaIP[p.podrocjecertificiranja]);

                        let zadnjaprijava=p.prijave?.filter(i=>i.shema=='IP'&&i.sezona==sezona-1).sort((a,b)=>(new Date(b.updatedAt)-new Date(a.updatedAt)))[0]
                        console.log("zadnjaprijava")
                        console.log(zadnjaprijava)
                        let gerkiprijava=zadnjaprijava?.prijava?.gerki;
                        if(gerkipc.length<=0&&gerkiprijava)
                             gerkipc=gerkiprijava.filter(g=>g.sezona==(sezona-1)&&g?.kontrolaIP&&g.kontrolaIP[p.podrocjecertificiranja]);


                        


                        if(gerkipc.length<=0){
                            //tukaj nimam zadnjih prijav... bi blo treba dodati
                            //let zadnjaprijava=p.stranka.prijave.filter(i=>i.shema=='IP'&&i.sezona==sezona-1).sort((a,b)=>(new Date(b.updatedAt)-new Date(a.updatedAt)))[0]
                            //gerkipc=zadnjaprijava?.prijava?.gerki
                            }
                            //vzami gerke iz prijave

                        let vsota=gerkipc.reduce((a,c)=>{return a+=c.povrsina; },0)
                        p.ippovrsine[p.podrocjecertificiranja]=vsota;
                        
                        cena=this.ipcenaizpovrsine(vsota,p.podrocjecertificiranja);

                    //}



                    //Vue.set(p,"ippovrsine",povrsine);
                    Vue.set(p,"ipcena",cena);
                    Vue.set(p,'povrsinaIP',vsota.toFixed())
                    
                    Vue.set(p,'povrsinaIP',vsota.toFixed())
                    for (let neskladje of p.neskladja.filter(n=>n.skladnost=="NE"))
                    {
                        neskladje.kontrola=p;
                        this.neskladja.push(neskladje)

                    }    
                            
                    

                }
                

                
            }
            console.log(this.gridData)
            if(next)
                next();
        });
    }
        ,
        ...mapActions('kontrola', ['loadVse']),
        spremenistolpce (event)  {
			let value=event.target.value;
            for (let col of this.columns){
                if(value.find(i=>i.field==col.field)){
                    if(!col.hidden){
                    Vue.set(col,"hidden",true)
                    console.log("skrivam")
                }
            }
                else{
                    if(col.hidden){
                    Vue.set(col,"hidden",false)
                    console.log("odkrivam")
                    }
            }
                    
            }
                console.log(this.columns);

                const dataState = {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                filter: this.filter,
            
            };
            this.dataResult = process( this.gridData, dataState);
            this.hiddenColumns2=this.columns.filter(c=>c.hidden);
			//let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.sezona&&s.shema==this.shema);
            //Vue.set(this.ip.prijava.obseg,podshema,[...event.target.value])
			//console.log(this.ip.prijava.obseg);
        },
        nogaNazivVsot: function (h, emptyElement , props, listeners ) {
            return h('span', {}, ['Število:']);
        },
        nogaSteviloKontrol: function (h, emptyElement , props, listeners ) {
          if(this.dataResult.data)
            return h('span', {}, [kendo.toString(this.dataResult.data.length,"n0")]);
        },
       
        nogaStMidov: function (h, emptyElement , props, listeners ) {
            console.log(this.dataResult.data)
          if(this.dataResult.data){
            var counts = {};
                for (var i = 0; i < this.dataResult.data.length; i++) {
                     counts[this.dataResult.data[i]?.stranka?.kmgmid] = 1 + (counts[this.dataResult.data[i]?.stranka?.kmgmid] || 0);
                }
                 return h('span', {}, [kendo.toString(Object.keys(counts).length,"n0")]);
            }
           
        },
        formatDate: function (h, emptyElement , props, listeners ) {
        
            return h('td', {attrs:{colspan:1}}, [kendo.toString(kendo.parseDate(props.dataItem[props.field]),'d')]);
        },
    

      
        sezonaChange(event) {
            const sezona = event.value;
            
            this.$router.push({ path: this.$route.path, query: { sezona:sezona.sezona,title:this.$route.query.title} })
            this.dataSezona=sezona;
            //this.loadVse({sezona:this.dataSezona.sezona,shema:this.$route.query.title});
            
     


        },

        
        createAppState: function(dataState) {
            console.log("createAppState");
            this.take = dataState.take;
            this.skip = dataState.skip?dataState.skip:0;
            this.group = dataState.group;
            this.filter = dataState.filter;
            this.sort = dataState.sort;
           
        },

        dataStateChange (event) {
            console.log("DataStateChange");
            console.log(event);
            this.createAppState(event.data);
         
            this.dataResult = process(this.gridData, {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                filter: this.filter,
                group: this.group
            });
         

        },
      
        exportExcel () {
            this.saveExcel({
                data: process(this.gridData, {
                sort: this.sort,
                filter: this.filter,
              
            }).data,
                fileName: this.dataSezona.sezona+"_KONTROLE",
                columns: this.columns.filter(i=>!i.hidden)
            });
        },
        ukaz(ime,kontrola,event){
            var shema=this.$route.query.title;
            var sezona=this.dataSezona.sezona;
            var pridelovalecid=kontrola.pridelovalecid;
            var kontrolaid=kontrola._id;
            var podshema=kontrola.podrocjecertificiranja;

            if(event.ctrlKey){
                const routeData = this.$router.resolve({ name: ime, params: { podshema:podshema,sezona:sezona,shema:shema,pridelovalecid:pridelovalecid,kontrolaid:kontrolaid} });
                window.open(routeData.href, '_blank');
            }
            else
                this.$router.push({ name: ime, params: { podshema:podshema,sezona:sezona,shema:shema,pridelovalecid:pridelovalecid,kontrolaid:kontrolaid} })
        },
        prenesiobrazecip(kontrola){
            var shema=this.$route.query.title;
            var sezona=this.dataSezona.sezona;
            var pridelovalecid=kontrola.pridelovalecid;
            var kontrolaid=kontrola._id;
            var podshema=kontrola.podrocjecertificiranja;
            obrazecService.vrniIpKontrolniList(sezona,pridelovalecid,kontrolaid).then(obrazec=>{
                console.log(obrazec);
            })

        },
        prenesiobrazecipnr(kontrola){
            var shema=this.$route.query.title;
            var sezona=this.dataSezona.sezona;
            var pridelovalecid=kontrola.pridelovalecid;
            var kontrolaid=kontrola._id;
            var podshema=kontrola.podrocjecertificiranja;
            obrazecService.vrniIpKontrolniListNR(sezona,pridelovalecid,kontrolaid).then(obrazec=>{
                console.log(obrazec);
            })

        },

        dodelikontrole () {
            this.$router.push({ name: "dodelikontroleip", params: { sezona:this.dataSezona.sezona,shema:this.$route.query.title} })
           
        },
        
     
        pageChangeHandler: function(event) {
            console.log(event);
            this.skip = event.page.skip;
            this.take = event.page.take;
           
        }
        
    }
};
</script>

